/** THE STRING VALUES IN HERE MUST MATCH WHAT IS IN DOTCMS!!!
 *
 * These values are used in dropdowns in the Alert content type in dotcms.
 */

export enum AlertTriggerToDisplay {
  LOGGED_IN = 'LOGGED_IN',
  LOGGED_OUT = 'LOGGED_OUT',
}

export enum AlertDisplayConditionUserState {
  USER_NOT_ENROLLED = 'USER_NOT_ENROLLED',

  USER_ENROLLED = 'USER_ENROLLED',

  /** Users can still add Cashless even if they are already enrolled in the ESPP. */
  USER_ENROLLED_IN_ESPP_AND_ELIGIBLE_FOR_CASHLESS = 'USER_ENROLLED_IN_ESPP_AND_ELIGIBLE_FOR_CASHLESS',

  /** Not really implemented */
  USER_WITH_PURCHASE_IN_PAST_YEAR = 'USER_WITH_PURCHASE_IN_PAST_YEAR',

  /** Plan has been suspended by the issuer */
  USER_PLAN_SUSPENDED = 'USER_PLAN_SUSPENDED',
}

export enum AlertDisplayConditionTime {
  SHOW_ALWAYS = 'SHOW_ALWAYS',

  CUSTOM_DATE = 'CUSTOM_DATE',

  /** All available enrollments are closed but scheduled enrollment is allowed */
  ALL_ENROLLMENTS_FINISHED_SCHEDULED_ENROLLMENT_OPEN = 'ALL_ENROLLMENTS_FINISHED_SCHEDULED_ENROLLMENT_OPEN',

  /** All available internal enrollments have the same period and are open */
  ALL_ENROLLMENTS_OPEN_SAME_PERIODS = 'ALL_ENROLLMENTS_OPEN_SAME_PERIODS',

  /** All available internal enrollments have the same period and are closed */
  ALL_ENROLLMENTS_FINISHED_SAME_PERIODS = 'ALL_ENROLLMENTS_FINISHED_SAME_PERIODS',

  /** Only the ESPP enrollment is open and we expect the Cashless Participation enrollment later */
  ESPP_ONLY_ENROLLMENT_OPEN_DIFFERENT_PERIODS = 'ESPP_ONLY_ENROLLMENT_OPEN_DIFFERENT_PERIODS',

  /** This is a quiet period between ESPP and Cashless Participation enrollments. */
  ESPP_ENROLLMENT_FINISHED_CASHLESS_ENROLLMENT_NOT_STARTED_DIFFERENT_PERIODS = 'ESPP_ENROLLMENT_FINISHED_CASHLESS_ENROLLMENT_NOT_STARTED_DIFFERENT_PERIODS',

  /** Enrollments for the ESPP and the Cashless Participation are currently open,
   *  although their periods are not the same. */
  ESPP_AND_CASHLESS_ENROLLMENTS_OPEN_DIFFERENT_PERIODS = 'ESPP_AND_CASHLESS_ENROLLMENTS_OPEN_DIFFERENT_PERIODS',

  /** Only the Cashless Participation enrollment is open */
  CASHLESS_ONLY_ENROLLMENT_OPEN_DIFFERENT_PERIODS = 'CASHLESS_ONLY_ENROLLMENT_OPEN_DIFFERENT_PERIODS',

  /** Enrollments do not have the same period and they are closed */
  ALL_ENROLLMENTS_FINISHED_DIFFERENT_PERIODS = 'ALL_ENROLLMENTS_FINISHED_DIFFERENT_PERIODS',

  /** After EOI start and before it's deadline * */
  EOI_OPEN = 'EOI_OPEN',

  /** EOI deadline exceeded and enrollment is still open * */
  EOI_DEADLINE_EXCEEDED_BUT_ENROLLMENT_OPEN = 'EOI_DEADLINE_EXCEEDED_BUT_ENROLLMENT_OPEN ',
}
